var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 7c.556 0 1 .448 1 1v3c0 .556-.448 1-1 1H8c-.556 0-1-.448-1-1V8c0-.556.448-1 1-1ZM4 7c.556 0 1 .448 1 1v3c0 .556-.448 1-1 1H1c-.556 0-1-.448-1-1V8c0-.556.448-1 1-1Zm0-7c.556 0 1 .448 1 1v3c0 .556-.448 1-1 1H1c-.556 0-1-.448-1-1V1c0-.556.448-1 1-1Zm7 0c.556 0 1 .448 1 1v3c0 .556-.448 1-1 1H8c-.556 0-1-.448-1-1V1c0-.556.448-1 1-1Z"
})));
export default SvgViewGrid;